import React from 'react';
import Header from "../../../../components/layout/headers/Header";
import Sidebar from '../../../../components/layout/navigation/sidebar/DynamicSidebar';
import AgentReportsTable from './AgentReportsTable';

const AgentReports = () => {
    return (
        <>
            <Header />
            <Sidebar />
            <div className="content-body">
                <div className="w-full px-4">
                    <AgentReportsTable />
                </div>
            </div>
        </>
    );
}

export default AgentReports;
